/** Kleine helpers voor de eigenaarskant, los van de componenten. */

/** De vier kleuren uit het ontwerp (ronde 20I, 20L, 20U). */
export const presetColors = ['#A0552F', '#6E5A3E', '#7C6C86', '#4F6B5B']

/**
 * Een link zonder schema en zonder slash op het eind. Wat er onder een QR-code
 * staat is wat je overtypt als scannen niet lukt, en dan tikt niemand "https://".
 */
export function readable(url: string): string {
  return url.replace(/^https?:\/\//, '').replace(/\/$/, '')
}
